import React from 'react';


const Myreview = () => {

   

    return (
       <div>
           <h1 className="my-10">No Reviews</h1>
       </div>
    );
};

export default Myreview;